module.exports = __webpack_public_path__ + "img/personal.c4372805.svg";